module.exports = __webpack_public_path__ + "static/media/399JamesPBrawleyDrNWNW_2018-06-12_80.0fc85646.jpg";